(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CarSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.GooglePlaces($form.find('.google-places'));

		$('#carsearch-pickup_date').on('dp.change', function populateDropoff(event) {
			if (event.date) {
				$('#carsearch-dropoff_date').data('DateTimePicker')
					.date(event.date.add(1, 'days'));
			}
		});
	};
}(jQuery, window.Adzuki || {}));
